import { isValidProductLevel } from '../../utils/typeguards';
import { useHasHigherProductLevelInProductInventory } from '../inventory/useHighestProductLevel';
import { useOwnedBundleForProduct } from '../inventory/useProductInventory';
import { useProductDetails } from '../product/useProductDetails';
/**
 * Hook to determine if purchase motions should be overridden with special CTAs.
 *
 * Checks for three override conditions:
 * 1. DISABLED_DOWNGRADE - User owns a higher tier product in the same category
 * 2. REDIRECT_MARKETING_PLUS - User owns Marketing Plus Suite
 * 3. REDIRECT_CUSTOMER_PLATFORM - User owns CRM Suite
 *
 * @param productApiName - The API name of the product to check overrides for
 * @returns Override type and loading state
 */
export const usePurchaseMotionOverrides = productApiName => {
  const {
    productDetails,
    loading: productDetailsLoading
  } = useProductDetails({
    productApiName
  });
  const {
    hasHigherProductLevel: hasHigherTieredProduct,
    loading: hasHigherTieredProductLoading
  } = useHasHigherProductLevelInProductInventory({
    productLevel: isValidProductLevel(productDetails === null || productDetails === void 0 ? void 0 : productDetails.productLevel) ? productDetails === null || productDetails === void 0 ? void 0 : productDetails.productLevel : undefined,
    skuCategoryName: productDetails === null || productDetails === void 0 ? void 0 : productDetails.skuCategoryName,
    skip: productDetailsLoading
  });
  const {
    bundleType: ownedBundleType,
    loading: ownedBundleTypeLoading
  } = useOwnedBundleForProduct({
    apiName: productApiName
  });
  const loading = productDetailsLoading || hasHigherTieredProductLoading || ownedBundleTypeLoading;
  if (loading) {
    return {
      type: 'NONE',
      loading: true
    };
  }
  if (hasHigherTieredProduct) {
    return {
      type: 'DISABLED_DOWNGRADE',
      loading: false
    };
  }
  if (ownedBundleType === 'MARKETING_PLUS_SUITE') {
    return {
      type: 'REDIRECT_MARKETING_PLUS',
      loading: false
    };
  }
  if (ownedBundleType === 'CRM_SUITE') {
    return {
      type: 'REDIRECT_CUSTOMER_PLATFORM',
      loading: false
    };
  }
  return {
    type: 'NONE',
    loading: false
  };
};